var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"transform":"rotate(90deg)"},attrs:{"src":require('@/assets/images/gamas/66/pared.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }